import { render, staticRenderFns } from "./SystemSubModule.vue?vue&type=template&id=207893da&"
import script from "./SystemSubModule.vue?vue&type=script&lang=js&"
export * from "./SystemSubModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports